export default __webpack_public_path__ + "static/media/ArrowLeft.226f3f90.svg";